import Vue from "vue";
import VueRouter from "vue-router";
import Home from '../views/Home';
import About from '../views/About';
import Guest from '../views/Guest';
import Agenda from '../views/Agenda';
import Venue from '../views/Venue';
import Contact from '../views/Contact';


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/About",
    name: "About",
    component: About,
  },
  {
    path: "/Guest",
    name: "Guest",
    component: Guest,
  },
  {
    path: "/Agenda",
    name: "Agenda",
    component: Agenda,
  },
  {
    path: "/Venue",
    name: "Venue",
    component: Venue,
  },
  {
    path: "/Contact",
    name: "Contact",
    component: Contact,
  }
];


const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;